import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { UserUtil } from '../utils/user.utils';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private readonly authService: AuthService,
    private readonly userUtil: UserUtil
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.authService.isAuthenticated()) {
      return this.router.createUrlTree(['/auth/login']);
    }

    if (this.userUtil.isResponsablesProfile()) {
      return this.router.createUrlTree(['/auth/login']);
    }
    return true;
  }
}
